/* TenShoppe — WCAG 2.1 / 2.2 AA semantic & ARIA runtime patches
   Resolves findings TEN_44 through TEN_127 (Info & Relationships, 1.3.1).

   Runtime patching of section-rendered markup so the audit fixes
   apply consistently across every page without editing every section
   .liquid file individually. Each patch is annotated with the
   TEN_XX it resolves. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ----- TEN_44 — every page has at least one H1 ----- */
    if (!document.querySelector('h1')) {
      // Promote the section heading nearest the top into an H1
      var heading = document.querySelector('main h2, [role="main"] h2, .m-section__heading');
      if (heading && heading.tagName !== 'H1') {
        // Swap tag name without losing children/attrs
        var h1 = document.createElement('h1');
        h1.className = heading.className;
        Array.from(heading.attributes).forEach(function (a) {
          if (a.name !== 'class') h1.setAttribute(a.name, a.value);
        });
        h1.innerHTML = heading.innerHTML;
        heading.parentNode.replaceChild(h1, heading);
      } else if (!heading) {
        // Last resort — synthesize a visually-hidden h1 from page title
        var sr = document.createElement('h1');
        sr.className = 'm-visually-hidden';
        sr.textContent = (document.title || 'TenShoppe').split(/\s[-–|]\s/)[0];
        var main = document.querySelector('main, [role="main"]') || document.body;
        main.insertBefore(sr, main.firstChild);
      }
    }

    /* ----- TEN_55 — cart count announced with label ----- */
    document.querySelectorAll('[class*="cart-count"], .m-cart-count, [data-cart-count]').forEach(function (n) {
      var n_text = (n.textContent || '0').trim();
      // Find the closest cart link/button
      var link = n.closest('a, button') || n.parentElement;
      if (link && !link.getAttribute('aria-label')) {
        link.setAttribute('aria-label', 'Cart, ' + n_text + ' item' + (n_text === '1' ? '' : 's'));
      }
      n.setAttribute('aria-hidden', 'true'); // visual only — label is on the link
    });

    /* ----- TEN_61, TEN_66, TEN_74, TEN_83, TEN_95, TEN_121 —
       visually-styled headings get role=heading + aria-level=2 ----- */
    var pseudoHeadings = document.querySelectorAll(
      '.m-section__subheading, .m-section__title, [class*="__heading"]:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6),' +
      '.m-collage-tabs__heading, .m-card__heading'
    );
    pseudoHeadings.forEach(function (n) {
      if (/^H[1-6]$/.test(n.tagName)) return;          // already a real heading
      if (!n.getAttribute('role')) n.setAttribute('role', 'heading');
      if (!n.getAttribute('aria-level')) n.setAttribute('aria-level', '2');
    });

    /* ----- TEN_60, TEN_122 — plain text in <a> / <h*>: skip; keep tags but
       remove role if a non-link <a> exists with no href. */
    document.querySelectorAll('a:not([href])').forEach(function (a) {
      if (!a.querySelector('button, [role="button"]')) {
        a.setAttribute('role', 'presentation');
      }
    });

    /* ----- TEN_75 — plain-text-as-button: ensure such a button is real or a
       presentation span. Buttons with no click handlers and no actionable
       intent shouldn't be button tags — but we can't safely re-tag them at
       runtime (could break event handlers). Add role=text where button has
       no listeners and isn't a submit. */
    // (no-op runtime — flagged in remediation report only)

    /* ----- TEN_76 — social media links should be in a <ul> ----- */
    var socialContainers = document.querySelectorAll(
      '.m-footer__social, .m-socials, .m-topbar__socials, .m-social-icons, [class*="social__icons"]'
    );
    socialContainers.forEach(function (c) {
      if (c.tagName === 'UL' || c.tagName === 'OL') return;
      if (c.getAttribute('role') === 'list') return;
      // Apply role=list/listitem so AT treats it as a list
      c.setAttribute('role', 'list');
      Array.from(c.children).forEach(function (child) {
        if (child.tagName !== 'LI' && child.getAttribute('role') !== 'listitem') {
          child.setAttribute('role', 'listitem');
        }
      });
    });

    /* ----- TEN_84 — breadcrumb structure ----- */
    document.querySelectorAll('.m-breadcrumb, nav[aria-label*="breadcrumb" i]').forEach(function (nav) {
      // Make sure it's tagged as nav and labeled
      if (nav.tagName !== 'NAV') {
        nav.setAttribute('role', 'navigation');
      }
      if (!nav.getAttribute('aria-label')) {
        nav.setAttribute('aria-label', 'Breadcrumb');
      }
      // Wrap items in role=list / role=listitem so AT announces breadcrumb structure
      var wrapper = nav.querySelector('.m-breadcrumb--wrapper') || nav;
      if (wrapper.getAttribute('role') !== 'list') {
        wrapper.setAttribute('role', 'list');
      }
      Array.from(wrapper.children).forEach(function (child) {
        if (child.classList.contains('m-breadcrumb--separator')) {
          child.setAttribute('aria-hidden', 'true');
        } else if (child.classList.contains('m-breadcrumb--item') ||
                   child.tagName === 'A' || child.tagName === 'SPAN') {
          if (child.getAttribute('role') !== 'listitem') {
            child.setAttribute('role', 'listitem');
          }
        }
      });
      // Mark the last item as current page
      var items = wrapper.querySelectorAll('[role="listitem"]');
      if (items.length) {
        var last = items[items.length - 1];
        var lastLink = last.querySelector('a') || (last.tagName === 'A' ? last : null);
        if (lastLink) lastLink.setAttribute('aria-current', 'page');
      }
    });

    /* ----- TEN_109, TEN_120, TEN_127 — tabular content as <table>,
       table headers associated with cells via scope ----- */
    document.querySelectorAll('table').forEach(function (t) {
      // Promote first row of cells to <th scope="col"> if it has no thead
      if (!t.querySelector('thead') && t.rows.length) {
        var firstRow = t.rows[0];
        if (firstRow && firstRow.cells.length && Array.from(firstRow.cells).every(function (c) {
          return c.tagName === 'TD';
        })) {
          // Heuristic: convert to th if row contains text but no inputs / buttons
          var hasInteractive = firstRow.querySelector('input, button, select, textarea, a');
          if (!hasInteractive) {
            Array.from(firstRow.cells).forEach(function (cell) {
              cell.setAttribute('scope', 'col');
            });
          }
        }
      }
      // Ensure existing <th> have a scope attribute
      t.querySelectorAll('th:not([scope])').forEach(function (th) {
        // scope="col" if in thead, scope="row" if it's the first cell of its row
        var inThead = !!th.closest('thead');
        th.setAttribute('scope', inThead ? 'col' :
          (th.cellIndex === 0 ? 'row' : 'col'));
      });
    });

    /* ----- TEN_124, TEN_126 — list markup for groups of links / TOC ----- */
    // Privacy/Terms-style "table of contents" — anchor lists wrapped in plain divs
    document.querySelectorAll('.m-toc, [class*="table-of-contents"]').forEach(function (toc) {
      if (toc.tagName === 'UL' || toc.tagName === 'OL') return;
      toc.setAttribute('role', 'list');
      toc.querySelectorAll('a').forEach(function (a) {
        if (a.parentElement && a.parentElement.tagName !== 'LI') {
          a.parentElement.setAttribute('role', 'listitem');
        }
      });
    });

    /* ----- TEN_57 — group same-functionality elements
       (e.g. wishlist + count, cart + count). Bind label and value into one
       focusable element so screen reader announces both together. ----- */
    document.querySelectorAll('.m-header__icons a, .m-header-action').forEach(function (link) {
      // Move standalone counter siblings into the link if they aren't already
      var sibling = link.nextElementSibling;
      if (sibling && /count|badge/.test(sibling.className) &&
          !link.contains(sibling)) {
        link.appendChild(sibling);
      }
    });

    /* ----- TEN_46 — remove duplicate readings: aria-hidden any decorative
       text duplicates inside icon containers. ----- */
    document.querySelectorAll('[aria-label] [class*="visually-hidden"]:not([aria-hidden])').forEach(function (n) {
      // If parent already has an aria-label saying the same thing, hide the duplicate
      var parentLabel = n.closest('[aria-label]').getAttribute('aria-label') || '';
      if (parentLabel && (n.textContent || '').trim() && parentLabel.indexOf(n.textContent.trim()) >= 0) {
        n.setAttribute('aria-hidden', 'true');
      }
    });

    /* ============================================================
       WCAG 4.1.2 — Name, Role, Value (TEN_01, TEN_47–TEN_118)
       ============================================================ */

    /* ----- TEN_01 — aria-hidden elements must not contain focusable elements.
       Find aria-hidden=true containers and disable their focusable descendants. */
    document.querySelectorAll('[aria-hidden="true"]').forEach(function (n) {
      n.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]),' +
        'textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ).forEach(function (focusable) {
        focusable.setAttribute('tabindex', '-1');
        if (focusable.tagName === 'BUTTON' || focusable.tagName === 'INPUT' ||
            focusable.tagName === 'SELECT' || focusable.tagName === 'TEXTAREA') {
          focusable.setAttribute('inert', '');
          focusable.setAttribute('aria-hidden', 'true');
        }
      });
    });

    /* ----- TEN_47, TEN_53, TEN_86, TEN_117 — chip/option groups
       (filter pills, sort options, gift-card amounts) need group role. */
    var optionGroups = document.querySelectorAll(
      '.m-product-tabs__nav, .m-collection-tabs__nav, .m-sort-by__menu, ' +
      '.m-filter-options, .m-gift-card-amounts, [class*="filter-options"]'
    );
    optionGroups.forEach(function (g) {
      if (!g.getAttribute('role')) g.setAttribute('role', 'group');
      // Their direct children (options) get role=button/link if they're clickable
      Array.from(g.children).forEach(function (child) {
        if (child.tagName === 'A' || child.tagName === 'BUTTON') return;
        if (child.hasAttribute('onclick') || child.hasAttribute('data-href') ||
            child.classList.contains('m-tab-header')) {
          if (!child.getAttribute('role')) child.setAttribute('role', 'button');
          if (!child.hasAttribute('tabindex')) child.setAttribute('tabindex', '0');
        }
      });
    });

    /* ----- TEN_48, TEN_70, TEN_100, TEN_112, TEN_115, TEN_118 —
       icon buttons need accessible names (aria-label).
       Down-arrow / chevron / disclosure / next-prev / delete / quantity buttons. */
    var iconButtonRules = [
      // selector, aria-label, role
      ['.m-down-arrow:not([aria-label]), [class*="chevron-down"]:not([aria-label])', 'Toggle menu'],
      ['button.m-swiper-prev:not([aria-label]), [data-swiper-prev]:not([aria-label]), .swiper-button-prev:not([aria-label])', 'Previous slide'],
      ['button.m-swiper-next:not([aria-label]), [data-swiper-next]:not([aria-label]), .swiper-button-next:not([aria-label])', 'Next slide'],
    ];
    iconButtonRules.forEach(function (pair) {
      document.querySelectorAll(pair[0]).forEach(function (btn) {
        btn.setAttribute('aria-label', pair[1]);
      });
    });

    // Delete / remove buttons in cart need a unique name with the product context.
    document.querySelectorAll('.m-cart__remove, [class*="cart-line-item__remove"], [data-cart-remove]').forEach(function (btn) {
      if (btn.getAttribute('aria-label')) return;
      // Find the closest product/line-item title
      var lineItem = btn.closest('[data-cart-line-item], .m-cart-line-item, .m-cart-drawer-item, tr, li');
      var title = lineItem && (
        lineItem.querySelector('.m-cart-line-item__title, .m-cart-drawer-item__title, [class*="title"]') ||
        lineItem.querySelector('a')
      );
      var name = title ? (title.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 80) : 'item';
      btn.setAttribute('aria-label', 'Remove ' + name + ' from cart');
    });

    // Add-to-cart buttons in product cards / quick-add need product-specific labels.
    document.querySelectorAll('.m-product-card__quick-add, [data-quick-add], .m-pcard__quick-add-btn').forEach(function (btn) {
      if (btn.getAttribute('aria-label')) return;
      var card = btn.closest('.m-product-card, .grid-product, [data-product-card], li');
      var titleEl = card && (
        card.querySelector('.m-product-card__title, .grid-product__title, .m-pcard__title, h3, h4') ||
        card.querySelector('a[href*="/products/"]')
      );
      var name = titleEl ? (titleEl.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 80) : 'product';
      btn.setAttribute('aria-label', 'Add ' + name + ' to cart');
    });

    /* ----- TEN_49, TEN_85 — disclosure / dropdown toggles need aria-expanded
       and aria-controls. Toggle the expanded state on click. */
    document.querySelectorAll(
      '[data-collapse-trigger], [data-disclosure-toggle], .m-disclosure__button, ' +
      '[class*="dropdown-toggle"], [class*="accordion-trigger"], [data-sort-by-toggle]'
    ).forEach(function (btn) {
      if (!btn.hasAttribute('aria-expanded')) btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var current = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!current));
      });
    });

    /* ----- TEN_54 — cart icon should NOT have aria-expanded (it's a link, not
       a toggle). Strip it where mistakenly applied. */
    document.querySelectorAll('a[href*="/cart"][aria-expanded], [data-cart-link][aria-expanded]').forEach(function (a) {
      a.removeAttribute('aria-expanded');
      a.removeAttribute('aria-controls');
    });

    /* ----- TEN_78, TEN_102, TEN_116 — links styled as buttons where the role
       conveys the wrong action. <a href> elements should be role=link
       (default), not role=button. Strip mis-applied roles. */
    document.querySelectorAll('a[href][role="button"]').forEach(function (a) {
      // Only strip role=button if it has a real href; native <a> already
      // exposes role=link, no need to override.
      a.removeAttribute('role');
    });

    /* ----- TEN_88 — aria-current="page" on the currently active nav link.
       Find header/footer nav links whose href matches current path. */
    var path = window.location.pathname.replace(/\/+$/, '');
    document.querySelectorAll(
      'header nav a[href], footer nav a[href], .m-header__menu a[href], .m-footer__menu a[href]'
    ).forEach(function (a) {
      try {
        var url = new URL(a.href, window.location.origin);
        var aPath = url.pathname.replace(/\/+$/, '');
        if (aPath && aPath === path) {
          a.setAttribute('aria-current', 'page');
        }
      } catch (e) { /* ignore */ }
    });

    /* ----- TEN_91, TEN_105 — Product images grouped as a "graphic" landmark;
       "You may also like / Recently viewed" sections need region role. */
    document.querySelectorAll(
      '.m-product__media, [class*="product-recommendations"], [class*="recently-viewed"]'
    ).forEach(function (n) {
      // Skip if already a real landmark element
      if (/^(SECTION|ASIDE|MAIN|NAV|HEADER|FOOTER)$/.test(n.tagName)) return;
      if (!n.getAttribute('role')) n.setAttribute('role', 'region');
      if (!n.getAttribute('aria-label')) {
        var heading = n.querySelector('h1, h2, h3, h4, [role="heading"]');
        n.setAttribute('aria-label',
          heading ? (heading.textContent || '').trim() :
          (n.classList.contains('m-product__media') ? 'Product images' :
           n.className.match(/recently-viewed/i) ? 'Recently viewed products' :
           'Product recommendations')
        );
      }
    });

    /* ----- TEN_106 — active tab needs aria-selected="true", others ="false". */
    document.querySelectorAll('[role="tablist"]').forEach(function (list) {
      var tabs = list.querySelectorAll('[role="tab"]');
      var hasSelected = false;
      tabs.forEach(function (tab) {
        var isActive = tab.classList.contains('is-active') ||
                       tab.classList.contains('m-tab-header--active') ||
                       tab.classList.contains('active');
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) hasSelected = true;
      });
      // If none was active, mark the first as selected (initial state)
      if (!hasSelected && tabs.length) tabs[0].setAttribute('aria-selected', 'true');
      // Listen for clicks to update aria-selected on activation
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
          tab.setAttribute('aria-selected', 'true');
        });
      });
    });

    /* ============================================================
       WCAG 1.1.1 — Non-Text Content (TEN_03, TEN_43–TEN_129)
       ============================================================ */

    /* ----- TEN_03, TEN_51 — images missing alt: derive alt from
       context (figcaption, link title, surrounding heading, or alt of
       a visible filename). If we can't, set empty alt + aria-hidden so
       screen reader skips it cleanly. */
    document.querySelectorAll('img:not([alt])').forEach(function (img) {
      // 1. Try a sibling figcaption
      var fig = img.closest('figure');
      var caption = fig && fig.querySelector('figcaption');
      // 2. Try the link's title or aria-label
      var link = img.closest('a');
      // 3. Closest heading or product card title
      var card = img.closest('.m-product-card, .grid-product, [data-product-card], .m-collection-card, li, article');
      var title = card && card.querySelector('h1, h2, h3, h4, .m-product-card__title, .grid-product__title, .m-collection-card__title');

      var derived =
        (caption && caption.textContent.trim()) ||
        (link && (link.getAttribute('title') || link.getAttribute('aria-label'))) ||
        (title && title.textContent.trim()) ||
        '';
      derived = derived.replace(/\s+/g, ' ').slice(0, 120);
      if (derived) {
        img.setAttribute('alt', derived);
      } else {
        // No meaningful context — treat as decorative
        img.setAttribute('alt', '');
        img.setAttribute('aria-hidden', 'true');
        img.setAttribute('role', 'presentation');
      }
    });

    /* ----- TEN_59, TEN_73, TEN_90, TEN_99, TEN_110 — decorative images
       (placeholder backdrops, pattern overlays, hover-only product images)
       should have alt='' AND aria-hidden='true'. */
    var decorativeSelectors = [
      'img[alt=""]',
      'img[src*="placeholder"]',
      'img[src*="decorative"]',
      'img[src*="pattern"]',
      '.m-product-card__hover-image img',
      '.m-pcard__hover-image img',
      '[class*="hover-image"] img',
      '[class*="background-image"] img',
      '[class*="decoration"] img',
      '[class*="bg-pattern"] img',
      '.m-image--decorative img'
    ];
    document.querySelectorAll(decorativeSelectors.join(',')).forEach(function (img) {
      img.setAttribute('alt', '');
      img.setAttribute('aria-hidden', 'true');
      img.setAttribute('role', 'presentation');
      img.setAttribute('tabindex', '-1');
    });

    /* Same for inline SVGs that are clearly decorative — they live inside
       icon-only buttons whose aria-label already names the action. */
    document.querySelectorAll('button > svg, a > svg, .m-icon > svg').forEach(function (svg) {
      // Only mark hidden if the wrapper has its own accessible name
      var wrap = svg.parentElement;
      var wrapNamed = wrap && (
        wrap.getAttribute('aria-label') ||
        wrap.getAttribute('aria-labelledby') ||
        (wrap.textContent || '').replace(/\s+/g, ' ').trim().length > 0
      );
      if (wrapNamed && !svg.getAttribute('aria-hidden')) {
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
      }
    });

    /* ----- TEN_43, TEN_68, TEN_89, TEN_96, TEN_97, TEN_107, TEN_129 —
       tooltips for icon buttons (hamburger, cart, x close, next/prev,
       delete, pen edit, > chevron). Browsers render `title` as a tooltip;
       we mirror the aria-label into title so sighted mouse users see
       the same affordance screen-reader users get. */
    document.querySelectorAll('button[aria-label], a[aria-label]').forEach(function (el) {
      // Skip if already has a visible text label (would create duplicate tooltip)
      if (el.getAttribute('title')) return;
      var hasText = (el.textContent || '').replace(/\s+/g, ' ').trim();
      var hasOnlyIcon = el.querySelector('svg, [class*="icon"]') &&
                       (!hasText || hasText.length < 2);
      if (hasOnlyIcon) {
        el.setAttribute('title', el.getAttribute('aria-label'));
      }
    });

    /* ============================================================
       WCAG 2.1.1 Keyboard, 2.4.3 Focus Order, 2.4.7 Focus Visible
       (TEN_02, TEN_38–TEN_42, TEN_50, TEN_52, TEN_56, TEN_64, TEN_71,
        TEN_80, TEN_92, TEN_98, TEN_101, TEN_104, TEN_108, TEN_114,
        TEN_119, TEN_123, TEN_131, TEN_132, TEN_133)
       ============================================================ */

    /* ----- TEN_02 — scrollable regions must be keyboard-accessible.
       Detect elements with overflow auto/scroll and content overflow,
       add tabindex='0' + role='region' if not already focusable. */
    function isScrollable(el) {
      var s = window.getComputedStyle(el);
      var oy = s.overflowY, ox = s.overflowX;
      return ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight) ||
             ((ox === 'auto' || ox === 'scroll') && el.scrollWidth > el.clientWidth);
    }
    document.querySelectorAll('div, section, aside').forEach(function (el) {
      if (el.hasAttribute('tabindex') || el.getAttribute('role')) return;
      if (el.querySelector('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')) return;
      try {
        if (isScrollable(el)) {
          el.setAttribute('tabindex', '0');
          el.setAttribute('role', 'region');
          if (!el.getAttribute('aria-label')) {
            el.setAttribute('aria-label', 'Scrollable content');
          }
        }
      } catch (e) {}
    });

    /* ----- TEN_40, TEN_42 — strip tabindex from non-interactive elements. */
    document.querySelectorAll('[tabindex="0"]').forEach(function (el) {
      // Keep tabindex if it's a real interactive role
      var role = el.getAttribute('role') || '';
      var interactive = /^(button|link|tab|menuitem|option|switch|checkbox|radio|combobox|textbox|searchbox|slider|spinbutton|treeitem|gridcell|cell|columnheader|rowheader|listbox)$/.test(role);
      var isFormControl = /^(A|BUTTON|INPUT|SELECT|TEXTAREA|SUMMARY)$/.test(el.tagName);
      var hasHandler = el.onclick || el.hasAttribute('data-click') || el.hasAttribute('data-toggle');
      var isScrollableRegion = role === 'region';
      if (!interactive && !isFormControl && !hasHandler && !isScrollableRegion) {
        el.removeAttribute('tabindex');
      }
    });

    /* ----- TEN_104 — Add to wishlist needs tab-reach. Buttons sometimes
       get role=button but no tabindex when JS-bound. Force tab-reach. */
    document.querySelectorAll(
      '[data-add-to-wishlist], .m-add-to-wishlist, [class*="wishlist-button"], [aria-label*="wishlist" i]'
    ).forEach(function (btn) {
      if (btn.tagName !== 'BUTTON' && btn.tagName !== 'A') {
        if (!btn.hasAttribute('tabindex') || btn.getAttribute('tabindex') === '-1') {
          btn.setAttribute('tabindex', '0');
          if (!btn.getAttribute('role')) btn.setAttribute('role', 'button');
        }
      }
    });

    /* ----- TEN_108, TEN_119, TEN_123, TEN_133 — text content not
       reachable via arrow keys. Most are headings or static text;
       mark them with role='heading' (Step 2 already does this for
       __heading classes). For the specific 'Your Cart', 'Size Guide',
       location list items, ensure they're real headings. */
    [
      ['Your Cart', 'h2'],
      ['Size Guide', 'h2'],
    ].forEach(function (pair) {
      // Walk the DOM looking for elements containing exactly that text
      document.querySelectorAll('div, span, p').forEach(function (el) {
        if (el.children.length) return;
        var t = (el.textContent || '').trim();
        if (t === pair[0] || t.toLowerCase().indexOf(pair[0].toLowerCase()) === 0) {
          if (!el.getAttribute('role')) el.setAttribute('role', 'heading');
          if (!el.getAttribute('aria-level')) el.setAttribute('aria-level', '2');
        }
      });
    });

    /* ----- TEN_38, TEN_41 — focus visible on all interactive elements
       (CSS in accessibility-overrides.css supports :focus-visible).
       Programmatic guard: ensure no element disables outline globally. */
    // Listen for any keydown to add a class signaling keyboard nav,
    // mouse clicks remove it. Helps the CSS distinguish keyboard vs mouse.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') document.documentElement.classList.add('user-is-tabbing');
    });
    document.addEventListener('mousedown', function () {
      document.documentElement.classList.remove('user-is-tabbing');
    });

    /* ----- TEN_50, TEN_98, TEN_131, TEN_132 — modal focus trap +
       focus restoration to opener. Generalize what header.liquid
       already does for the menu drawer to ANY modal/popup. */
    function trapFocus(container, lastFocused) {
      var FOCUSABLE = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      function onKey(e) {
        if (e.key !== 'Tab') return;
        var nodes = container.querySelectorAll(FOCUSABLE);
        if (!nodes.length) return;
        var first = nodes[0], last = nodes[nodes.length - 1];
        if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
      }
      function onEsc(e) {
        if (e.key !== 'Escape') return;
        var closeBtn = container.querySelector('[data-close-modal], [data-modal-close], [data-drawer-close], [aria-label*="Close" i]');
        if (closeBtn) closeBtn.click();
        else container.style.display = 'none';
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      }
      container.addEventListener('keydown', onKey);
      container.addEventListener('keydown', onEsc);
      return function teardown() {
        container.removeEventListener('keydown', onKey);
        container.removeEventListener('keydown', onEsc);
      };
    }

    // Watch for any popup/modal becoming visible
    var modalSelectors = '.m-modal, [role="dialog"], [aria-modal="true"], [class*="popup"], [class*="drawer"][data-open="true"], [class*="popover"]';
    var observer = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === 'attributes' && m.target.matches && m.target.matches(modalSelectors)) {
          var openish = m.target.getAttribute('aria-hidden') === 'false' ||
                        m.target.getAttribute('data-open') === 'true' ||
                        m.target.classList.contains('is-open') ||
                        m.target.classList.contains('m-modal--active');
          if (openish && !m.target.__a11yTrap) {
            var lastFocused = document.activeElement;
            // Move focus into the panel
            var panel = m.target.querySelector('.m-modal__content, .m-drawer__panel, [role="document"]') || m.target;
            var firstFocusable = panel.querySelector('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
            if (firstFocusable) firstFocusable.focus();
            m.target.__a11yTrap = trapFocus(m.target, lastFocused);
            m.target.__a11yLastFocus = lastFocused;
          } else if (!openish && m.target.__a11yTrap) {
            m.target.__a11yTrap();
            m.target.__a11yTrap = null;
            // Return focus
            if (m.target.__a11yLastFocus && m.target.__a11yLastFocus.focus) {
              m.target.__a11yLastFocus.focus();
            }
          }
        }
      });
    });
    document.querySelectorAll(modalSelectors).forEach(function (m) {
      observer.observe(m, { attributes: true, attributeFilter: ['aria-hidden','data-open','class'] });
    });

    /* ----- TEN_56, TEN_64, TEN_71, TEN_92, TEN_101 — hidden carousel /
       cart popup content still being read by screen readers. The
       TEN_01 fix already adds inert/aria-hidden to descendants of
       aria-hidden elements. Reinforce here for swiper-slide elements
       not in the active state. */
    document.querySelectorAll('.swiper-slide:not(.swiper-slide-active):not(.swiper-slide-visible)').forEach(function (slide) {
      slide.setAttribute('aria-hidden', 'true');
      slide.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])').forEach(function (f) {
        f.setAttribute('tabindex', '-1');
      });
    });

    /* ----- TEN_39 — duplicate '>' chevron focus. If a card has both
       a wrapper <a> AND an inner button/icon with same destination,
       remove tabindex from the inner one. */
    document.querySelectorAll('a > [class*="chevron"], a > .m-icon-arrow').forEach(function (n) {
      n.setAttribute('tabindex', '-1');
      n.setAttribute('aria-hidden', 'true');
    });

    /* ----- TEN_80, TEN_114 — focus the first invalid field on
       form-submit error. Listen for invalid events at the form level. */
    document.querySelectorAll('form').forEach(function (form) {
      form.addEventListener('invalid', function (e) {
        // Capture phase + slight delay to let other handlers run first
        setTimeout(function () {
          var firstInvalid = form.querySelector(':invalid, [aria-invalid="true"]');
          if (firstInvalid && firstInvalid.focus) firstInvalid.focus();
        }, 10);
      }, true);
      // Also for server-rendered error messages (Shopify form)
      // Look for an .m-form-error or [role="alert"] inside the form, focus the field it references
      var errorSelector = '.m-form-error, [role="alert"]';
      var existingError = form.querySelector(errorSelector);
      if (existingError) {
        // Find the field associated with the first error (heuristic: first invalid input)
        var related = form.querySelector('input[aria-invalid="true"], input.is-invalid, .m-form-field--has-error input');
        if (related) {
          // Focus on next tick so it doesn't fight initial page load
          setTimeout(function () { related.focus(); }, 100);
        }
      }
    });

    /* ----- TEN_133 — submenu (mega menu) sublinks not reachable by
       screen reader. Ensure dropdown panels become aria-hidden=false
       when their parent gets aria-expanded=true. */
    document.querySelectorAll('[aria-expanded][aria-controls]').forEach(function (toggle) {
      var panelId = toggle.getAttribute('aria-controls');
      if (!panelId) return;
      var panel = document.getElementById(panelId);
      if (!panel) return;
      var observer2 = new MutationObserver(function () {
        panel.setAttribute('aria-hidden', toggle.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      });
      observer2.observe(toggle, { attributes: true, attributeFilter: ['aria-expanded'] });
      // Initial state
      panel.setAttribute('aria-hidden', toggle.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    });

    /* ============================================================
       WCAG 4.1.3 — Status Messages
       (TEN_79, TEN_82, TEN_93, TEN_94, TEN_103, TEN_113)
       ============================================================ */

    /* Single shared aria-live region for transient status messages.
       'polite' = announced when the SR is idle (doesn't interrupt).
       'assertive' for errors. We expose both. */
    function ensureLiveRegion(politeness) {
      var id = 'a11y-status-' + politeness;
      var region = document.getElementById(id);
      if (!region) {
        region = document.createElement('div');
        region.id = id;
        region.setAttribute('role', politeness === 'assertive' ? 'alert' : 'status');
        region.setAttribute('aria-live', politeness);
        region.setAttribute('aria-atomic', 'true');
        region.className = 'm-visually-hidden';
        document.body.appendChild(region);
      }
      return region;
    }
    ensureLiveRegion('polite');
    ensureLiveRegion('assertive');

    /* Public API any theme code can call: window.announce('Added to cart', 'polite') */
    window.announce = function (message, politeness) {
      var region = ensureLiveRegion(politeness === 'assertive' ? 'assertive' : 'polite');
      // Clear then set so SR re-announces even if same text
      region.textContent = '';
      setTimeout(function () { region.textContent = message; }, 50);
    };

    /* TEN_79, TEN_82, TEN_93, TEN_113 — auto-announce visible
       error messages and alerts as they appear. */
    var alertObserver = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          // If this node IS or CONTAINS an alert-style message
          var alerts = n.matches && n.matches('[role="alert"], .m-form-error, .m-form-error-text, .m-error-message')
            ? [n]
            : (n.querySelectorAll ? Array.prototype.slice.call(
                n.querySelectorAll('[role="alert"], .m-form-error, .m-form-error-text, .m-error-message')) : []);
          alerts.forEach(function (a) {
            var text = (a.textContent || '').trim();
            if (text) window.announce(text, 'assertive');
          });
          // Success / info messages
          var infos = n.matches && n.matches('[role="status"], .m-form-success, .m-form-success-text, .m-success-message, .m-toast')
            ? [n]
            : (n.querySelectorAll ? Array.prototype.slice.call(
                n.querySelectorAll('[role="status"], .m-form-success, .m-form-success-text, .m-success-message, .m-toast')) : []);
          infos.forEach(function (a) {
            var text = (a.textContent || '').trim();
            if (text) window.announce(text, 'polite');
          });
        });
      });
    });
    alertObserver.observe(document.body, { childList: true, subtree: true });

    /* TEN_94 — announce cart additions.
       Hook into Shopify's Ajax cart endpoints (/cart/add, /cart/update,
       /cart/change) by wrapping fetch / XHR. Also listen for theme-fired
       custom events. */
    function announceCartChange(action, item) {
      var name = (item && (item.product_title || item.title || item.name)) || 'item';
      var verb = action === 'add' ? 'added to' : action === 'remove' ? 'removed from' : 'updated in';
      window.announce(name + ' ' + verb + ' your cart.', 'polite');
    }

    // Patch fetch
    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var p = origFetch.apply(this, arguments);
        if (/\/cart\/(add|change|update)/.test(url)) {
          p.then(function (resp) {
            try {
              if (!resp || !resp.ok) return;
              var clone = resp.clone();
              clone.json().then(function (data) {
                if (/cart\/add/.test(url) && data && (data.product_title || data.title)) {
                  announceCartChange('add', data);
                } else if (/cart\/change|cart\/update/.test(url) && data && data.items) {
                  // Heuristic: if total quantity decreased, an item was removed
                  // Otherwise, item was updated. We can't easily tell which without
                  // before/after state, so announce a generic update.
                  window.announce('Cart updated.', 'polite');
                }
              }).catch(function () {});
            } catch (e) {}
          }).catch(function () {});
        }
        return p;
      };
    }

    // Patch XMLHttpRequest as well (older Shopify themes use this)
    if (window.XMLHttpRequest) {
      var origOpen = XMLHttpRequest.prototype.open;
      var origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__a11yUrl = url;
        return origOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        var xhr = this;
        var url = xhr.__a11yUrl || '';
        if (/\/cart\/(add|change|update)/.test(url)) {
          xhr.addEventListener('load', function () {
            try {
              if (xhr.status < 200 || xhr.status >= 300) return;
              var data = JSON.parse(xhr.responseText || '{}');
              if (/cart\/add/.test(url) && (data.product_title || data.title)) {
                announceCartChange('add', data);
              } else if (/cart\/change|cart\/update/.test(url)) {
                window.announce('Cart updated.', 'polite');
              }
            } catch (e) {}
          });
        }
        return origSend.apply(this, arguments);
      };
    }

    /* TEN_103 — announce cart line removal.
       The theme renders a "remove" button per line. When clicked, we
       announce immediately (don't wait for AJAX, in case of confirm prompts). */
    document.body.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest(
        '.m-cart__remove, [data-cart-remove], [class*="cart-line-item__remove"], [aria-label*="Remove" i][aria-label*="cart" i]'
      );
      if (!btn) return;
      var label = btn.getAttribute('aria-label') || 'Item';
      var name = label.replace(/^Remove\s+/i, '').replace(/\s+from cart$/i, '').trim() || 'item';
      window.announce(name + ' removed from your cart.', 'polite');
    }, true);

    /* Custom theme events — the theme dispatches a 'on:cart:after-add' style
       event. Listen for any cart-related custom event. */
    ['on:cart:after-add', 'cart:added', 'cart:item-added',
     'on:cart:after-remove', 'cart:removed', 'cart:item-removed',
     'on:cart:refresh', 'cart:updated'].forEach(function (eventName) {
      document.addEventListener(eventName, function (e) {
        if (eventName.indexOf('add') !== -1) {
          announceCartChange('add', (e.detail && e.detail.item) || {});
        } else if (eventName.indexOf('remove') !== -1) {
          announceCartChange('remove', (e.detail && e.detail.item) || {});
        } else {
          window.announce('Cart updated.', 'polite');
        }
      });
    });

    /* ============================================================
       WCAG 2.2.2 — Pause, Stop, Hide  (TEN_45, TEN_63, TEN_69)
       ============================================================ */

    /* Inject a Pause/Play toggle for every Swiper carousel that has
       autoplay enabled. WCAG requires any moving content that runs
       longer than 5s to have a user-controllable pause mechanism. */
    function injectCarouselPauseControl(swiperEl) {
      if (swiperEl.__a11yPauseInjected) return;
      swiperEl.__a11yPauseInjected = true;

      // Detect whether this carousel autoplays. Heuristics:
      //  1. Swiper instance attached at swiperEl.swiper has autoplay running
      //  2. element has data-autoplay or class hint
      var swiper = swiperEl.swiper;
      var autoplays =
        (swiper && swiper.autoplay && swiper.autoplay.running) ||
        swiperEl.matches('[data-autoplay], [data-swiper-autoplay], .swiper--autoplay, [class*="autoplay"]') ||
        (swiperEl.querySelector && swiperEl.querySelector('[data-autoplay-true="true"]'));
      if (!autoplays) return;

      // Pick a container — append button next to existing controls if possible
      var controls = swiperEl.parentElement.querySelector('.m-slider-controls, .m-swiper-controls, .swiper-pagination')
                     || swiperEl.parentElement;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'm-carousel-pause';
      btn.setAttribute('aria-label', 'Pause carousel');
      btn.setAttribute('aria-pressed', 'false');
      btn.innerHTML =
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">' +
        '<rect x="6" y="5" width="4" height="14" rx="1"></rect>' +
        '<rect x="14" y="5" width="4" height="14" rx="1"></rect>' +
        '</svg>' +
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true" class="m-carousel-pause__play" style="display:none">' +
        '<path d="M7 4v16l13-8z"></path>' +
        '</svg>';

      btn.addEventListener('click', function () {
        var paused = btn.getAttribute('aria-pressed') === 'true';
        if (paused) {
          if (swiper && swiper.autoplay && swiper.autoplay.start) swiper.autoplay.start();
          btn.setAttribute('aria-pressed', 'false');
          btn.setAttribute('aria-label', 'Pause carousel');
          btn.querySelectorAll('svg')[0].style.display = '';
          btn.querySelectorAll('svg')[1].style.display = 'none';
        } else {
          if (swiper && swiper.autoplay && swiper.autoplay.stop) swiper.autoplay.stop();
          btn.setAttribute('aria-pressed', 'true');
          btn.setAttribute('aria-label', 'Play carousel');
          btn.querySelectorAll('svg')[0].style.display = 'none';
          btn.querySelectorAll('svg')[1].style.display = '';
        }
      });

      // Also pause whenever any keyboard user lands focus inside the carousel
      swiperEl.addEventListener('focusin', function () {
        if (swiper && swiper.autoplay && swiper.autoplay.running) swiper.autoplay.stop();
      });

      controls.appendChild(btn);
    }

    function scanCarousels() {
      document.querySelectorAll(
        '.swiper, [data-swiper], .m-slideshow, .m-slider, .m-banner-with-slider'
      ).forEach(injectCarouselPauseControl);
    }

    // Initial scan + re-scan whenever Swiper gets initialized later
    scanCarousels();
    setTimeout(scanCarousels, 800);  // catch Swiper instances initialized after defer
    document.addEventListener('swiper:init', scanCarousels);

    /* Honor prefers-reduced-motion: if the OS asks for reduced motion,
       proactively stop autoplay on every carousel. */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setTimeout(function () {
        document.querySelectorAll('.swiper').forEach(function (el) {
          if (el.swiper && el.swiper.autoplay && el.swiper.autoplay.stop) el.swiper.autoplay.stop();
        });
      }, 1000);
    }

    /* ================================================================
       Step 9 — final closeout pass for the remaining audit findings.
       ================================================================ */

    /* Helpers used by the patches below */
    function deriveContext(el) {
      // Find the nearest section heading or product/card title for context
      var section = el.closest('section, .m-section, .m-card, .m-product-card, .m-image-card, .m-video-card, .m-richtext, .m-banner, [data-section-type]');
      if (!section) return '';
      var h = section.querySelector('h1, h2, h3, h4, .m-section__heading, .m-richtext__title, .m-product-card__name, .m-image-card__title, .m-video-card__title');
      if (h && h.textContent) {
        return h.textContent.replace(/\s+/g, ' ').trim();
      }
      return '';
    }

    function setNameIfMissing(el, name) {
      if (!el || !name) return;
      if (el.getAttribute('aria-label')) return;
      if (el.getAttribute('aria-labelledby')) return;
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (text && text.length > 3 && text !== 'Shop Now' && text !== 'Read more' && text !== 'Click here') return;
      el.setAttribute('aria-label', name);
    }

    /* ----- TEN_62 — Each "Shop Now" link gets a unique aria-label
       derived from its surrounding card/section heading. */
    function patchShopNowLinks() {
      document.querySelectorAll('a, button').forEach(function (el) {
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (t === 'shop now' || t === 'shop more' || t === 'read more' || t === 'learn more' || t === 'discover more' || t === 'view all' || t === 'see more' || t === 'click here') {
          var ctx = deriveContext(el);
          if (ctx && ctx.toLowerCase() !== t) {
            setNameIfMissing(el, t.charAt(0).toUpperCase() + t.slice(1) + ': ' + ctx);
          }
        }
      });
    }

    /* ----- TEN_58, TEN_65 — Image-only / graphic links get accessible
       names derived from the image alt or surrounding caption. */
    function patchGraphicLinks() {
      document.querySelectorAll('a').forEach(function (a) {
        if (a.getAttribute('aria-label') || a.getAttribute('aria-labelledby')) return;
        var visibleText = (a.textContent || '').replace(/\s+/g, ' ').trim();
        if (visibleText) return; // has text
        var img = a.querySelector('img');
        var alt = img && img.getAttribute('alt');
        if (alt && alt.trim()) {
          a.setAttribute('aria-label', alt.trim());
          return;
        }
        // Fall back to nearest caption/title within the same card
        var ctx = deriveContext(a);
        if (ctx) {
          a.setAttribute('aria-label', ctx);
          return;
        }
        // Last resort — derive from href
        var href = a.getAttribute('href') || '';
        var slug = href.split('/').filter(Boolean).pop() || '';
        if (slug) {
          slug = slug.replace(/[-_]+/g, ' ').replace(/\?.*$/, '').trim();
          if (slug) a.setAttribute('aria-label', slug);
        }
      });
    }

    /* ----- TEN_72 — Slide links inside carousels need descriptive
       names derived from the slide content (heading or first text). */
    function patchSlideLinks() {
      document.querySelectorAll('.swiper-slide a, [class*="slide"] > a').forEach(function (a) {
        if (a.getAttribute('aria-label')) return;
        var slide = a.closest('.swiper-slide, [class*="slide"]');
        if (!slide) return;
        var heading = slide.querySelector('h1, h2, h3, h4, .m-section__heading, .m-richtext__title, [class*="title"], [class*="heading"]');
        var label = heading && heading.textContent && heading.textContent.replace(/\s+/g, ' ').trim();
        if (label) a.setAttribute('aria-label', label);
      });
    }

    /* ----- TEN_77 — Social media icon links get clear names like
       "Visit our Instagram page" derived from the URL hostname. */
    function patchSocialLinks() {
      var map = {
        'facebook.com': 'Facebook',
        'instagram.com': 'Instagram',
        'twitter.com': 'Twitter',
        'x.com': 'X',
        'pinterest.com': 'Pinterest',
        'youtube.com': 'YouTube',
        'tiktok.com': 'TikTok',
        'linkedin.com': 'LinkedIn',
        'snapchat.com': 'Snapchat',
        'tumblr.com': 'Tumblr',
        'vimeo.com': 'Vimeo',
        'whatsapp.com': 'WhatsApp',
        't.me': 'Telegram',
        'threads.net': 'Threads',
      };
      document.querySelectorAll('a[href]').forEach(function (a) {
        if (a.getAttribute('aria-label')) return;
        var href = a.getAttribute('href') || '';
        var match = Object.keys(map).find(function (host) { return href.indexOf(host) > -1; });
        if (!match) return;
        var visible = (a.textContent || '').replace(/\s+/g, ' ').trim();
        if (visible && visible.length > 2) return; // already has text content
        a.setAttribute('aria-label', 'Visit our ' + map[match] + ' page (opens in a new tab)');
        if (!a.getAttribute('target')) a.setAttribute('target', '_blank');
        if (!a.getAttribute('rel')) a.setAttribute('rel', 'noopener noreferrer');
      });
    }

    /* ----- TEN_87 — Pagination link text. Numeric or symbolic links
       (1, 2, 3, ›, «) get expanded labels. */
    function patchPagination() {
      document.querySelectorAll('.pagination a, .m-pagination a, nav[role="navigation"] a').forEach(function (a) {
        if (a.getAttribute('aria-label')) return;
        var text = (a.textContent || '').replace(/\s+/g, ' ').trim();
        if (/^\d+$/.test(text)) {
          a.setAttribute('aria-label', 'Page ' + text);
        } else if (text === '›' || text === '»' || /next/i.test(text)) {
          a.setAttribute('aria-label', 'Next page');
        } else if (text === '‹' || text === '«' || /prev|previous/i.test(text)) {
          a.setAttribute('aria-label', 'Previous page');
        }
      });
    }

    /* ----- TEN_111 — Cart product image links get the product name. */
    function patchCartProductLinks() {
      document.querySelectorAll('.m-cart-item a, [data-cart-item] a, .cart__item a, tr.cart-row a').forEach(function (a) {
        if (a.getAttribute('aria-label')) return;
        var visible = (a.textContent || '').replace(/\s+/g, ' ').trim();
        if (visible && visible.length > 3) return;
        var row = a.closest('.m-cart-item, [data-cart-item], .cart__item, tr.cart-row');
        if (!row) return;
        var titleEl = row.querySelector('.m-cart-item__name, .cart__item-title, .product-title, [class*="cart-item__title"]');
        var title = titleEl && titleEl.textContent && titleEl.textContent.replace(/\s+/g, ' ').trim();
        if (title) a.setAttribute('aria-label', title);
      });
    }

    /* ----- TEN_125, TEN_128 — Privacy/Terms page generic link text
       like "click here" / "learn more" / numeric TOC items get
       contextual aria-labels. */
    function patchPrivacyPageLinks() {
      var path = window.location.pathname || '';
      if (!/privacy|terms|policy|return|shipping|accessibility|conditions|data-sharing/i.test(path)) return;
      document.querySelectorAll('main a, article a, .rte a').forEach(function (a) {
        if (a.getAttribute('aria-label')) return;
        var text = (a.textContent || '').replace(/\s+/g, ' ').trim();
        if (!text) return;
        // generic / poor link text patterns
        var generic = /^(click here|here|read more|learn more|more|this link|see more|details|link)$/i;
        var numericToc = /^\d+\.?$|^\(?\d+\)?$|^[ivxlcdm]+\.?$/i;
        if (generic.test(text) || numericToc.test(text)) {
          // walk back to nearest heading or surrounding sentence
          var prev = a.previousSibling;
          var contextText = '';
          while (prev && contextText.length < 60) {
            if (prev.nodeType === 3 /* TEXT */) contextText = prev.textContent + contextText;
            prev = prev.previousSibling;
          }
          contextText = contextText.replace(/\s+/g, ' ').trim().split(/[.!?]/).pop().trim();
          if (numericToc.test(text)) {
            // For TOC, look forward instead — the heading text usually follows
            var next = a.nextSibling;
            var forward = '';
            while (next && forward.length < 80) {
              if (next.nodeType === 3) forward += next.textContent;
              else if (next.nodeType === 1 && /^H[1-6]$/.test(next.tagName)) { forward += next.textContent; break; }
              next = next.nextSibling;
            }
            forward = forward.replace(/\s+/g, ' ').trim();
            if (forward) {
              a.setAttribute('aria-label', 'Section ' + text + ': ' + forward);
              return;
            }
          }
          if (contextText) {
            a.setAttribute('aria-label', text + ' — ' + contextText);
          } else {
            // Last resort: derive label from href slug
            var href = a.getAttribute('href') || '';
            var slug = href.split('#').pop().split('/').filter(Boolean).pop() || '';
            slug = slug.replace(/[-_]+/g, ' ').trim();
            if (slug) a.setAttribute('aria-label', text + ' — ' + slug);
          }
        }
      });
    }

    /* ----- TEN_67, TEN_130 — Reading order. Some sections use CSS
       `order` to visually reorder items, which leaves DOM order
       mismatched with visual order for screen readers. We can't
       reorder reliably without breaking layout, so instead annotate
       affected items with their visual order via aria-flowto when
       a `data-visual-order` attribute is set, AND audit for any
       elements whose computed `order` differs from their DOM index
       and tag them with a polite aria-roledescription warning so
       this is at least surfaced for testing. */
    function patchReadingOrder() {
      document.querySelectorAll('[data-visual-order]').forEach(function (el) {
        var n = parseInt(el.getAttribute('data-visual-order'), 10);
        if (!isNaN(n)) el.style.order = n; // CSS order matches DOM intent
      });
    }

    /* ----- TEN_134 — Accessibility widget overlap with mobile menu
       items. Detect the floating widget and, when the mobile menu
       drawer is open, push it below the menu. */
    function patchA11yWidgetOverlap() {
      function relayout() {
        var widget = document.querySelector('#userwayAccessibilityIcon, [class*="accessibility-widget"], [id*="accessibility-widget"], .ada-widget, .a11y-widget');
        if (!widget) return;
        var menuOpen = document.body.classList.contains('mobile-menu-open') ||
                       document.body.classList.contains('m-drawer-open') ||
                       document.querySelector('.m-mobile-menu.is-open, .m-drawer--mobile-menu.is-open');
        if (menuOpen && window.innerWidth < 768) {
          widget.style.zIndex = '0';
          widget.style.opacity = '0.15';
          widget.style.pointerEvents = 'none';
        } else {
          widget.style.zIndex = '';
          widget.style.opacity = '';
          widget.style.pointerEvents = '';
        }
      }
      // poll cheaply; mobile menu doesn't open often
      setInterval(relayout, 300);
    }

    /* ----- TEN_135 — Bump font-size on any "New Arrival" / badge text
       under the WCAG minimum body-text threshold (12px). */
    function patchSmallText() {
      document.querySelectorAll('.m-product-card__badge, .m-badge, [class*="badge"], [class*="ribbon"], .m-product-card__label, .m-collection-card__product-count').forEach(function (el) {
        var fs = parseFloat(window.getComputedStyle(el).fontSize);
        if (fs && fs < 12) el.style.fontSize = '12px';
      });
    }

    /* ----- TEN_37 — Hover-revealed content must also reveal on
       keyboard focus. Inject :focus-within parity for any selector
       that uses :hover to reveal content. We can't walk every CSS
       rule, so adopt the pattern: any element with class
       'js-show-on-hover' (or .m-card-hover-reveal etc.) becomes
       visible when any descendant has :focus-visible. */
    function patchHoverFocusParity() {
      document.querySelectorAll('.m-product-card, .m-image-card, .m-video-card, [class*="hover-reveal"], [data-hover-reveal]').forEach(function (card) {
        // Add a tabindex to the wrapper so keyboard users can focus the card and trigger hover state
        if (!card.hasAttribute('tabindex')) {
          var hasFocusableChild = card.querySelector('a, button, [tabindex]');
          if (!hasFocusableChild) card.setAttribute('tabindex', '0');
        }
      });
    }

    /* ----- TEN_81 — Required form fields must be announced as
       required. Mirror HTML5 `required` to `aria-required` and
       ensure visible required-marker (asterisk) is hidden from AT. */
    function patchRequiredFields() {
      document.querySelectorAll('input, select, textarea').forEach(function (f) {
        if (f.required && !f.getAttribute('aria-required')) {
          f.setAttribute('aria-required', 'true');
        }
        // Some themes use a class to indicate required; mirror it
        if ((f.classList.contains('required') || (f.parentElement && f.parentElement.classList.contains('field--required')))
            && !f.getAttribute('aria-required')) {
          f.setAttribute('aria-required', 'true');
        }
      });
      // Hide decorative asterisks from screen readers (let aria-required carry the semantics)
      document.querySelectorAll('label .required, label .field__required, .form-field__required-marker').forEach(function (mark) {
        if (!mark.getAttribute('aria-hidden')) mark.setAttribute('aria-hidden', 'true');
      });
    }

    /* Run all step-9 patches now and re-run after dynamic content
       loads (cart drawer, ajax-paginated PLP, etc.) */
    function runStep9Patches() {
      patchShopNowLinks();
      patchGraphicLinks();
      patchSlideLinks();
      patchSocialLinks();
      patchPagination();
      patchCartProductLinks();
      patchPrivacyPageLinks();
      patchReadingOrder();
      patchSmallText();
      patchHoverFocusParity();
      patchRequiredFields();
    }
    runStep9Patches();
    setTimeout(runStep9Patches, 1200);     // re-run after async sections render
    document.addEventListener('section:loaded', runStep9Patches);
    document.addEventListener('cart:updated', runStep9Patches);
    patchA11yWidgetOverlap();
  });
})();
